module.exports = __webpack_public_path__ + "static/media/sun-big-cloud.dc2695a4.png";